import { get } from './utils';

export const keepAlive = async () => await get<null>(`v1/session/keep-alive`);
